<template>
</template>

<script>
    import store from '../store';

    export default {
        computed: {
            refreshing() {
                return store.state.refreshStatus;
            },
        },
        methods: {
            refresh() {
                store.dispatch('refreshData');
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../assets/scss/partials/variables';

    .side-bar {
        position: absolute;
        top: $navHeaderHeight;
        left: 0;
        width: $sideBarWidth;
        height: calc(100vh - #{$navHeaderHeight});
        background-color: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/components/SideBar.vue